module.exports = __webpack_public_path__ + "index/img/kefuchatu.af67b81e.png";